<template>
  <div id="app">
    <v-app light>
      <v-toolbar dark color="primary" v-if="['Viewer', 'Login'].indexOf($route.name) == -1">
        <v-toolbar-title>TS Poseidon - Screen Management</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-side-icon class="hidden-md-and-up"></v-toolbar-side-icon>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat><v-icon>search</v-icon>Resin Dashboard</v-btn>
          <v-btn flat round v-on:click="logout"><v-icon>person</v-icon>Log out</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <router-view/>
    </v-app>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'App',
  methods: {
    logout: function(){
      firebase.auth().signOut().then( () => {
        this.$router.replace('login')
      });
    }
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue